import React from 'react';

import { flagStyles } from '../settings';

const SvgRS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4512px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgRS;
